export default {
  s: '%d segundos',
  smicro: '%d s',
  smid: '%d seg',

  ss: '%d segundos',
  ssmicro: '%d s',
  ssmid: '%d seg',

  m: '%d minuto',
  mmicro: '%d m',
  mmid: '%d min',

  mm: '%d minutos',
  mmmicro: '%d m',
  mmmid: '%d min',

  h: '%d hora',
  hmicro: '%d h',
  hmid: '%d hora',

  hh: '%d horas',
  hhmicro: '%d h',
  hhmid: '%d horas',

  d: '%d dia',
  dmicro: '%d d',
  dmid: '%d dia',

  dd: '%d dias',
  ddmicro: '%d d',
  ddmid: '%d dias',
};
